(() => {
  /* ibvr-play-fix-20260821 */
  /* ibvr-gif-strip-20260821 */
  /* ibvr-tweak-20260821 */
  const SELECTOR = '[data-ib-video-review-rail]';
  const MARQUEE_PX_PER_SEC = 28;
  const LOG = '[ib-video-review-rail]';
  const IN_VIEW = 0.18;
  const TOUCH_RESUME_MS = 1000;

  function hydratePoster(card) {
    const image = card.querySelector('[data-ib-video-review-poster]');
    if (!image || image.getAttribute('src')) return;
    if (card.dataset.posterSrc) image.src = card.dataset.posterSrc;
  }

  function installPlayIcon(icon) {
    if (!icon || icon.dataset.ibvrPlayIcon === 'svg') return;
    while (icon.firstChild) icon.removeChild(icon.firstChild);
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 12 12');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const poly = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    poly.setAttribute('points', '3.2,1.6 10.4,6 3.2,10.4');
    poly.setAttribute('fill', '#fff');
    svg.appendChild(poly);
    icon.appendChild(svg);
    icon.dataset.ibvrPlayIcon = 'svg';
  }

  function isClone(card) {
    return !!(card && card.dataset.ibvrClone === 'true');
  }

  function ensureVideo(card) {
    if (!card || isClone(card) || !card.dataset.videoSrc) return null;
    let video = card.querySelector('video.ib-video-review-card__video');
    if (video) return video;
    const media = card.querySelector('.ib-video-review-card__media');
    const button = card.querySelector('[data-ib-video-review-play]');
    if (!media) return null;
    video = document.createElement('video');
    video.className = 'ib-video-review-card__video';
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.controls = false;
    video.playsInline = true;
    video.preload = 'none';
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('loop', '');
    const label = button && button.getAttribute('aria-label');
    video.setAttribute('aria-label', label || 'Customer video review');
    video.addEventListener('error', () => {
      const err = video.error;
      console.warn(LOG, 'media error; keeping poster', {
        src: card.dataset.videoSrc,
        code: err && err.code,
        message: err && err.message
      });
      card.classList.remove('is-playing');
    });
    media.appendChild(video);
    return video;
  }

  function clearTracks(video) {
    if (!video) return;
    video.querySelectorAll('track').forEach((track) => track.remove());
  }

  function attachCaptions(video, card) {
    if (!video || !card || !card.dataset.trackSrc) return;
    if (video.querySelector('track')) return;
    const track = document.createElement('track');
    track.kind = 'captions';
    track.srclang = 'en';
    track.label = 'English';
    track.default = true;
    track.src = card.dataset.trackSrc;
    video.appendChild(track);
  }

  function attachSrc(video, card, preload, withCaptions) {
    const src = card.dataset.videoSrc;
    if (!src || !video) return;
    if (video.dataset.ibSrc === src && video.getAttribute('src') === src) {
      if (preload) video.preload = preload;
      if (withCaptions) attachCaptions(video, card);
      else clearTracks(video);
      return;
    }
    video.preload = preload || 'metadata';
    if (card.dataset.posterSrc) video.poster = card.dataset.posterSrc;
    video.src = src;
    video.dataset.ibSrc = src;
    clearTracks(video);
    if (withCaptions) attachCaptions(video, card);
  }

  function detachSrc(video, card) {
    if (!video) return;
    video.pause();
    if (!video.dataset.ibSrc && !video.getAttribute('src')) return;
    video.removeAttribute('src');
    video.removeAttribute('poster');
    clearTracks(video);
    video.load();
    delete video.dataset.ibSrc;
    video.preload = 'none';
    video.controls = false;
    video.muted = true;
    video.defaultMuted = true;
    if (card) card.classList.remove('is-playing', 'is-unmuted');
  }

  function releaseVideo(card) {
    const video = card && card.querySelector('video.ib-video-review-card__video');
    if (!video) return;
    detachSrc(video, card);
    video.remove();
  }

  function playMuted(video, card) {
    if (!video || !card || !card.dataset.videoSrc) return Promise.resolve();
    if (card.classList.contains('is-unmuted')) return Promise.resolve();
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    const attempt = () => video.play().then(() => {
      card.classList.add('is-playing');
    });
    const start = () => attempt().catch((first) => {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      return attempt().catch((second) => {
        console.warn(LOG, 'play failed; keeping poster', {
          src: card.dataset.videoSrc,
          name: second && second.name,
          message: second && second.message,
          firstName: first && first.name
        });
        card.classList.remove('is-playing');
      });
    });
    if (video.readyState >= 2) return start();
    return new Promise((resolve) => {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        video.removeEventListener('canplay', onReady);
        video.removeEventListener('error', onError);
        resolve(start());
      };
      const onReady = () => finish();
      const onError = () => {
        if (settled) return;
        settled = true;
        video.removeEventListener('canplay', onReady);
        video.removeEventListener('error', onError);
        console.warn(LOG, 'canplay never arrived; keeping poster', {
          src: card.dataset.videoSrc,
          code: video.error && video.error.code,
          message: video.error && video.error.message
        });
        card.classList.remove('is-playing');
        resolve();
      };
      video.addEventListener('canplay', onReady);
      video.addEventListener('error', onError);
      if (video.readyState >= 2) finish();
    });
  }

  function cardStep(track) {
    const card = track.querySelector('[data-ib-video-review-card]');
    if (!card) return 0;
    const gap = Number.parseFloat(getComputedStyle(track).columnGap || '0');
    return card.getBoundingClientRect().width + gap;
  }

  function scrollTrack(track, direction) {
    const step = cardStep(track);
    if (!step) return;
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  function cloneAsPoster(card) {
    const clone = card.cloneNode(true);
    clone.dataset.ibvrClone = 'true';
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-video-src');
    clone.removeAttribute('data-track-src');
    clone.querySelectorAll('video, track').forEach((el) => el.remove());
    const play = clone.querySelector('[data-ib-video-review-play]');
    if (play) {
      play.setAttribute('tabindex', '-1');
      play.setAttribute('aria-hidden', 'true');
      play.disabled = true;
    }
    const img = clone.querySelector('[data-ib-video-review-poster]');
    const poster = card.dataset.posterSrc;
    if (img && poster) {
      img.src = poster;
      img.removeAttribute('loading');
    }
    return clone;
  }

  function prepareLoop(track) {
    if (!track || track.dataset.ibvrCloned === 'true') return;
    const originals = [...track.querySelectorAll('[data-ib-video-review-card]')].filter((card) => !isClone(card));
    if (originals.length < 2) return;
    originals.forEach((card) => {
      track.appendChild(cloneAsPoster(card));
    });
    track.dataset.ibvrCloned = 'true';
    track.dataset.ibvrOriginalCount = String(originals.length);
  }

  function loopWidth(track) {
    const n = Number.parseInt(track.dataset.ibvrOriginalCount || '0', 10);
    const cards = [...track.querySelectorAll('[data-ib-video-review-card]')];
    if (!n || cards.length < n) return 0;
    const first = cards[0];
    const last = cards[n - 1];
    const gap = Number.parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    return (last.offsetLeft - first.offsetLeft) + last.offsetWidth + gap;
  }

  function init(root) {
    if (root.dataset.videoReviewReady === 'true') return;
    root.dataset.videoReviewReady = 'true';
    root.dataset.ibvrMode = 'gif-strip';

    const track = root.querySelector('[data-ib-video-review-track]');
    const controls = root.querySelector('.ib-video-reviews__controls');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    root.querySelectorAll('.ib-video-review-card__play-icon').forEach(installPlayIcon);
    if (track && !reducedMotion.matches) prepareLoop(track);
    root.querySelectorAll('.ib-video-review-card__play-icon').forEach(installPlayIcon);

    const allCards = [...root.querySelectorAll('[data-ib-video-review-card]')];
    const originals = allCards.filter((card) => !isClone(card));
    const clones = allCards.filter((card) => isClone(card));
    const ratios = new WeakMap();
    let marqueeRaf = 0;
    let lastTs = 0;
    let paused = false;
    let resumeTimer = 0;
    let waitTimer = 0;
    let syncQueued = false;
    let loopW = 0;
    let touchHeld = false;

    const measure = () => {
      loopW = track ? loopWidth(track) : 0;
    };

    const stopAutoAdvance = () => {
      paused = true;
      if (marqueeRaf) {
        window.cancelAnimationFrame(marqueeRaf);
        marqueeRaf = 0;
      }
      lastTs = 0;
      root.dataset.autoAdvance = 'paused';
    };

    const hasUnmuted = () => originals.some((card) => card.classList.contains('is-unmuted'));

    const tick = (ts) => {
      marqueeRaf = 0;
      if (paused || !track || reducedMotion.matches || hasUnmuted() || document.hidden || touchHeld) {
        root.dataset.autoAdvance = 'paused';
        return;
      }
      if (!loopW) measure();
      if (loopW <= 1 || track.scrollWidth <= track.clientWidth + 1) {
        root.dataset.autoAdvance = 'waiting';
        lastTs = 0;
        window.clearTimeout(waitTimer);
        waitTimer = window.setTimeout(startAutoAdvance, 400);
        return;
      }
      const dt = lastTs ? Math.min(48, ts - lastTs) / 1000 : 0;
      lastTs = ts;
      let x = track.scrollLeft + MARQUEE_PX_PER_SEC * dt;
      while (x >= loopW) x -= loopW;
      if (x < 0) x += loopW;
      track.scrollLeft = x;
      root.dataset.autoAdvance = 'running';
      marqueeRaf = window.requestAnimationFrame(tick);
    };

    const startAutoAdvance = () => {
      window.clearTimeout(resumeTimer);
      window.clearTimeout(waitTimer);
      if (hasUnmuted() || reducedMotion.matches || !track || touchHeld || document.hidden) {
        stopAutoAdvance();
        return;
      }
      paused = false;
      if (!marqueeRaf) {
        lastTs = 0;
        marqueeRaf = window.requestAnimationFrame(tick);
      }
      root.dataset.autoAdvance = 'running';
    };

    const pauseThenResume = (delay) => {
      stopAutoAdvance();
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(startAutoAdvance, delay);
    };

    const remuteCard = (card) => {
      const video = card.querySelector('video.ib-video-review-card__video');
      card.classList.remove('is-unmuted');
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.controls = false;
      video.setAttribute('muted', '');
      clearTracks(video);
    };

    const pickPrimary = () => {
      const unmuted = originals.find((card) => card.classList.contains('is-unmuted'));
      if (unmuted) return unmuted;
      let best = null;
      let bestR = -1;
      originals.forEach((card) => {
        const r = ratios.get(card) || 0;
        if (r > bestR) {
          bestR = r;
          best = card;
        }
      });
      if (best && bestR >= IN_VIEW) return best;
      return null;
    };

    const nextOriginal = (card) => {
      const i = originals.indexOf(card);
      if (i < 0 || originals.length < 2) return null;
      return originals[(i + 1) % originals.length];
    };

    const syncPlayback = () => {
      const primary = pickPrimary();
      const preloadNext = primary && !primary.classList.contains('is-unmuted') ? nextOriginal(primary) : null;

      originals.forEach((card) => {
        const isPrimary = card === primary;
        const isNext = card === preloadNext;
        const keep = isPrimary || isNext || card.classList.contains('is-unmuted');
        if (!keep) {
          releaseVideo(card);
          return;
        }
        const video = ensureVideo(card);
        if (!video) return;
        const unmuted = card.classList.contains('is-unmuted');
        if (isPrimary) {
          attachSrc(video, card, 'auto', unmuted);
          if (unmuted) {
            card.classList.add('is-playing');
          } else if (video.paused) {
            playMuted(video, card);
          } else {
            card.classList.add('is-playing');
          }
        } else {
          attachSrc(video, card, 'metadata', false);
          if (!video.paused) video.pause();
          card.classList.remove('is-playing');
        }
      });

      clones.forEach((card) => {
        releaseVideo(card);
      });
    };

    const queueSync = () => {
      if (syncQueued) return;
      syncQueued = true;
      window.requestAnimationFrame(() => {
        syncQueued = false;
        syncPlayback();
      });
    };

    const unmuteCard = (card) => {
      if (isClone(card)) return;
      stopAutoAdvance();
      const video = ensureVideo(card);
      if (!video || !card.dataset.videoSrc) return;
      originals.forEach((other) => {
        if (other === card) return;
        remuteCard(other);
        releaseVideo(other);
      });
      clones.forEach(releaseVideo);
      attachSrc(video, card, 'auto', true);
      video.controls = true;
      video.muted = false;
      video.defaultMuted = false;
      video.removeAttribute('muted');
      card.classList.add('is-unmuted', 'is-playing');
      const attempt = () => video.play();
      attempt().catch((first) => {
        console.warn(LOG, 'unmuted play rejected; retrying muted', first && first.message);
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        clearTracks(video);
        return attempt().then(() => {
          card.classList.remove('is-unmuted');
          video.controls = false;
          startAutoAdvance();
        }).catch((second) => {
          console.warn(LOG, 'play failed; keeping poster', {
            src: card.dataset.videoSrc,
            name: second && second.name,
            message: second && second.message
          });
          card.classList.remove('is-playing', 'is-unmuted');
          startAutoAdvance();
        });
      });
    };

    const updateControls = () => {
      if (controls) controls.hidden = true;
      measure();
      startAutoAdvance();
    };

    const posterObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, instance) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            hydratePoster(entry.target);
            instance.unobserve(entry.target);
          });
        }, { rootMargin: '240px 0px' })
      : null;

    const playObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (isClone(entry.target)) return;
            ratios.set(entry.target, entry.intersectionRatio);
          });
          queueSync();
        }, { root: track, threshold: [0, 0.1, 0.18, 0.35, 0.6, 1] })
      : null;

    originals.forEach((card) => {
      if (posterObserver) posterObserver.observe(card);
      else hydratePoster(card);
      if (playObserver) playObserver.observe(card);
      else ratios.set(card, 1);
      card.querySelector('[data-ib-video-review-play]')?.addEventListener('click', () => {
        unmuteCard(card);
      });
    });
    clones.forEach((card) => {
      hydratePoster(card);
    });

    if (!playObserver) queueSync();

    root.querySelector('[data-ib-video-review-prev]')?.addEventListener('click', () => {
      pauseThenResume(1600);
      scrollTrack(track, -1);
    });
    root.querySelector('[data-ib-video-review-next]')?.addEventListener('click', () => {
      pauseThenResume(1600);
      scrollTrack(track, 1);
    });

    if (track) track.addEventListener('scroll', queueSync, { passive: true });

    if (fineHover.matches) {
      root.addEventListener('mouseenter', stopAutoAdvance);
      root.addEventListener('mouseleave', startAutoAdvance);
      root.addEventListener('focusin', stopAutoAdvance);
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) startAutoAdvance();
      });
    }

    const onPointerDown = (event) => {
      if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
      touchHeld = true;
      stopAutoAdvance();
    };
    const onPointerUp = (event) => {
      if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
      touchHeld = false;
      pauseThenResume(TOUCH_RESUME_MS);
    };
    root.addEventListener('pointerdown', onPointerDown, { passive: true });
    root.addEventListener('pointerup', onPointerUp, { passive: true });
    root.addEventListener('pointercancel', onPointerUp, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoAdvance();
        originals.forEach((card) => {
          const video = card.querySelector('video');
          if (video && !video.paused) video.pause();
        });
      } else {
        queueSync();
        startAutoAdvance();
      }
    });
    reducedMotion.addEventListener?.('change', updateControls);
    window.addEventListener('resize', () => {
      measure();
      updateControls();
      queueSync();
    }, { passive: true });

    updateControls();
    queueSync();
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
